import { HistoryModel } from '../../../types/models';
import { formatChatDate } from '../CMShared';

interface ChatDetailsPanelProps {
	chat: HistoryModel;
	messageCount: number | null;
	imageCount: number | null;
	isLoadingMessages: boolean;
	isCurrentChat: boolean;
	onOpen: () => void;
	onExport: () => void;
}

export function ChatDetailsPanel({
	chat,
	messageCount,
	imageCount,
	isLoadingMessages,
	isCurrentChat,
	onOpen,
	onExport,
}: ChatDetailsPanelProps) {
	return (
		<div className="h-full flex flex-col">
			<div className="bg-neutral-500 rounded-small p-md border border-neutral-400">
				<div className="space-y-sm text-sm">
					<div>
						<span className="text-neutral-200 block mb-xs">
							Title:
						</span>
						<span className="text-neutral-100 font-medium line-clamp-2">
							{chat.title}
						</span>
					</div>
					<div className="flex justify-between">
						<span className="text-neutral-200">Created:</span>
						<span className="text-neutral-100 font-medium">
							{formatChatDate(chat.created_at)}
						</span>
					</div>
					<div className="flex justify-between">
						<span className="text-neutral-200">Last Updated:</span>
						<span className="text-neutral-100 font-medium">
							{formatChatDate(chat.last_updated)}
						</span>
					</div>
					<div className="flex justify-between">
						<span className="text-neutral-200">Message Count:</span>
						<span className="text-neutral-100 font-medium">
							{(() => {
								if (isLoadingMessages)
									return (
										<i className="fas fa-spinner fa-spin text-xs" />
									);
								if (messageCount !== null) return messageCount;
								return 'Unknown';
							})()}
						</span>
					</div>
					<div className="flex justify-between">
						<span className="text-neutral-200">Image Count:</span>
						<span className="text-neutral-100 font-medium">
							{isLoadingMessages ? (
								<i className="fas fa-spinner fa-spin text-xs" />
							) : (
								(imageCount ?? 0)
							)}
						</span>
					</div>
					<div className="flex justify-between">
						<span className="text-neutral-200">Status:</span>
						<span
							className={`font-medium ${isCurrentChat ? 'text-red-400' : 'text-neutral-300'}`}
						>
							{isCurrentChat ? 'Active' : 'Archived'}
						</span>
					</div>
				</div>
			</div>

			<div className="flex-1" />

			<div className="bg-neutral-500 rounded-small p-md border border-neutral-400 mt-md">
				<h4 className="text-sm font-medium text-neutral-100 mb-sm">
					Quick Actions
				</h4>
				<div className="space-y-xs">
					<button
						onClick={onOpen}
						className="w-full btn-secondary"
						type="button"
					>
						<i className="fas fa-external-link-alt mr-xs" />
						Open Chat
					</button>
					<button
						onClick={onExport}
						className="w-full px-6 py-2 rounded-small text-sm font-medium transition-colors duration-200 bg-red-600 hover:bg-red-500 text-neutral-100"
						type="button"
					>
						<i className="fas fa-download mr-xs" />
						Preview & Export Chat
					</button>
				</div>
			</div>
		</div>
	);
}
